export const environment = {
  production: false,
  BASE_ACS_URL: '',
  AIRFLOW_ONCE_URL: '',
  AIRFLOW_PERIODICALLY_URL: '',
};
